module.exports = __webpack_public_path__ + "img/stick_hiver_stade_alpin.501ef7cd.svg";